export default function cn(...args) {
  return args.filter((c) => !!c).join(' ')
}
